import { CHANNELS } from "../types/global.enum";
import apiService, { JiraApi } from "./api.service";
import digitalApiService from "./digitalApi.service";
import { getUserName } from "./user.service";

export const loadJiraUsers = async () => {
    const { data } = await JiraApi.get(`/users?username=${getUserName()}`);
    return data?.data;
}

export const loadJiraProjects = async () => {
    const { data } = await JiraApi.get(`/projects?username=${getUserName()}`);
    return data?.data;
}

export const loadJiraStatuses = async () => {
    const { data } = await JiraApi.get(`/issueStatus?username=${getUserName()}`);
    return data?.data;
}

export const createJiraTicket = async (body: any) => {
    const { data } = await JiraApi.post(`/issue`, { ...body });
    return data?.data;
}



export const updateTestResult = async (id: string, jira: string, channel: CHANNELS | null) => {
    const { data } = channel === CHANNELS.DIGITAL ? await digitalApiService.put(`/results/${id}?jiraTicket=${jira}`) : await apiService.put(`/results/${id}?jiraTicket=${jira}`);
    return data?.data;
}


export const updateJiraTicket = async (issueId: string, body: any) => {
    const { data } = await JiraApi.put(`/issue?username=${getUserName()}&issueId=${issueId}`, { ...body });
    return data?.data;
}


export const getJiraStatus = async (issueId: string) => {
    const { data } = await JiraApi.get(`/issue?username=${getUserName()}&issueId=${issueId}`);
    return data?.data;
}

export interface FeatureRequestTicketPayload {
    projectKey: string;
    summary: string;
    description: string;
    labels?: string[];
    assignee?: string;
    attachments?: File[];
}

export const createFeatureRequestTicket = async ({
    projectKey,
    summary,
    description,
    labels = [],
    assignee,
    attachments = [],
    
}: FeatureRequestTicketPayload) => {
    const uniqueLabels = Array.from(new Set(['feature-request', 'support-bot', ...labels.filter(Boolean)]));
    const payload = {
        project: projectKey,
        summary,
        description,
        issueType: 'New Feature',
        labels: uniqueLabels,
        // assignee: assignee || getUserName(),
        assignee: "712020:8530d9a0-4877-4201-9520-98e01691124f",
        username: getUserName(),
        
    };
    if (attachments.length > 0) {
        const formData = new FormData();
        formData.append('payload', JSON.stringify(payload));
        attachments.forEach((file) => {
            formData.append('attachments', file);
        });

        const { data } = await JiraApi.post(`/issue`, formData);

        return data?.data;
    }

    if (attachments.length > 0) {
        const formData = new FormData();
        formData.append('payload', JSON.stringify(payload));
        attachments.forEach((file) => {
            formData.append('attachments', file);
        });

        const { data } = await JiraApi.post(`/issue`, formData);

        return data?.data;
    }

    return await createJiraTicket(payload);
}

export interface RunSupportTicketPayload {
    projectKey: string;
    summary: string;
    description: string;
    labels?: string[];
    assignee?: string;
    attachments?: File[];
}

export const createRunSupportTicket = async ({
    projectKey,
    summary,
    description,
    labels = [],
    assignee,
    attachments = [],
}: RunSupportTicketPayload) => {
    const uniqueLabels = Array.from(new Set(['support-bot', 'run-overview', ...labels.filter(Boolean)]));
    const payload = {
        project: projectKey,
        summary,
        description,
        issueType: 'Bug',
        labels: uniqueLabels,
         // assignee: assignee || getUserName(),
         assignee: "712020:8530d9a0-4877-4201-9520-98e01691124f",
        username: getUserName(),
    };

    if (attachments.length > 0) {
        const formData = new FormData();
        formData.append('payload', JSON.stringify(payload));
        attachments.forEach((file) => {
            formData.append('attachments', file);
        });

        const { data } = await JiraApi.post(`/issue`, formData);

        return data?.data;
    }

    return await createJiraTicket(payload);
};

export interface SupportTicketPayload {
    projectKey: string;
    summary: string;
    description: string;
    labels?: string[];
    assignee?: string;
    attachments?: File[];
}

export const createSupportTicket = async ({
    projectKey,
    summary,
    description,
    labels = [],
    assignee,
    attachments = [],
}: SupportTicketPayload) => {
    const uniqueLabels = Array.from(new Set(['support-bot', 'support-request', ...labels.filter(Boolean)]));
    const payload = {
        project: projectKey,
        summary,
        description,
        issueType: 'Bug',
        labels: uniqueLabels,
        // assignee: assignee || getUserName(),
        assignee: "712020:8530d9a0-4877-4201-9520-98e01691124f",
        username: getUserName(),
    };

    if (attachments.length > 0) {
        const formData = new FormData();
        formData.append('payload', JSON.stringify(payload));
        attachments.forEach((file) => {
            formData.append('attachments', file);
        });

        const { data } = await JiraApi.post(`/issue`, formData);

        return data?.data;
    }

    return await createJiraTicket(payload);
};

export const getJiraTicketComments = async (issueId: string) => {
    const { data } = await JiraApi.get(`/issue/comments?username=${getUserName()}&issueId=${issueId}`);
    return data?.data;
};

export const addJiraTicketComment = async (issueId: string, comment: string) => {
    const { data } = await JiraApi.post(`/issue/comments?username=${getUserName()}&issueId=${issueId}`, { comment });
    return data?.data;
};

export const updateJiraTicketComment = async (issueId: string, commentId: string, comment: string) => {
    const { data } = await JiraApi.put(`/issue/comments?username=${getUserName()}&issueId=${issueId}&commentId=${commentId}`, { comment });
    return data?.data;
};
